import * as Core from '@skylab-shared/core';
import { FiscalDevicePaymentMethodsParametersModel, FiscalDeviceVatRatesParametersModel } from './fiscal-device-parameters.model';

export class FiscalDeviceModel extends Core.ModelBase {
    @Core.Property({ identifiable: true })
    public id: number;

    @Core.Property()
    public default: boolean;

    @Core.Property()
    @Core.Required('data-model.fiscalization.validation.name.no-empty')
    public name: string;

    @Core.Property(FiscalDevicePaymentMethodsParametersModel, { nullable: true })
    public paymentMethodsParameters: FiscalDevicePaymentMethodsParametersModel | null;

    @Core.Property(FiscalDeviceVatRatesParametersModel, { nullable: true })
    public vatRatesParameters: FiscalDeviceVatRatesParametersModel | null;
}
